export function useFilters() {
  const formatDate = (value) => {
    if (value) {
      const date = new Date(value);
      let month = date.getMonth() + 1;
      let day = date.getDate();

      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;

      return [day, month, date.getFullYear()].join("/");
    }
    return "Non saisie";
  };

  const uppercase = (value) => {
    return value ? value.toUpperCase() : "";
  };

  const roundSix = (value) => {
    return value ? value.toFixed(6) : value;
  };

  const formatRegion = (str) => {
    return str ? str.replaceAll(" ", "-") : ""
  };

  const formatDepartement = (str) => {
    if (!str) return ""
    const splitStr = str.toLowerCase().split(" ")
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
    }
    return splitStr.join(" ").replaceAll(" ", "-")
  };

  return {
    formatDate,
    uppercase,
    roundSix,
    formatRegion,
    formatDepartement
  }
}
